import { decryptData, encryptData } from "utils/dataCipherHelper";
import { instance as axios, setHeaders } from "../config/axiosInstance";


// Get link of upload file API
export const uploadFileApi = async (imageFile) => {
  const formData = new FormData()
  formData.append("surveyImage",imageFile)
  const responseData = await axios.post("survey/upload-survey-image", formData,setHeaders("multipart"));
  return responseData?.data;
};
